"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobOfferListItemResponseSchema = exports.JobOfferListItemResultSchema = exports.JobOfferListItemSchema = exports.JobOfferDetailResponseSchema = exports.JobOfferDetailResultSchema = exports.JobOfferDetailSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const schemas_1 = require("../../../schemas");
exports.JobOfferDetailSchema = schemas_1.JobOfferSchema;
exports.JobOfferDetailResultSchema = zod_1.default.object({ offer: exports.JobOfferDetailSchema });
exports.JobOfferDetailResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.JobOfferDetailResultSchema);
exports.JobOfferListItemSchema = schemas_1.JobOfferSchema;
exports.JobOfferListItemResultSchema = zod_1.default.object({ offers: exports.JobOfferListItemSchema.array() });
exports.JobOfferListItemResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.JobOfferListItemResultSchema);
